import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles } from '@glu/theming';
import { AccessibilityText } from '@glu/utilities-react';
import locale from '@glu/locale';
import styles from './MoveHandle.styles';

const useStyles = createUseStyles(styles);

const MoveHandle = (props) => {
  const classes = useStyles(props);
  const {
    setMovedX, setMovedY, onMove, posX, posY
  } = props;
  const [dragging, setDragging] = useState(false);
  const position = useRef({ x: posX, y: posY });
  const screen = useRef({ x: 0, y: 0 });

  const handleMouseDown = () => {
    setDragging(true);
  };

  const handleMouseUp = () => {
    setDragging(false);
  };

  const handleMouseMove = ({
    screenX, screenY, movementX, movementY
  }) => {
    let moveX = movementX;
    let moveY = movementY;

    // calculate if in ie not supporting movementx/y
    if (movementX === undefined) {
      moveX = (screen.current.x ? screenX - screen.current.x : 0);
      moveY = (screen.current.y ? screenY - screen.current.y : 0);
      screen.current = {
        x: screenX,
        y: screenY
      };
    }

    if (dragging) {
      const pos = position.current;
      position.current = {
        x: pos.x + moveX,
        y: pos.y + moveY
      };
      setMovedX(position.current.x);
      setMovedY(position.current.y);
      onMove?.({ posX: position.current.x, posY: position.current.y });
    }
  };

  useEffect(() => {
    window.addEventListener('mousemove', handleMouseMove);
    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  });

  useEffect(() => {
    window.addEventListener('mouseup', handleMouseUp);
    return () => {
      window.removeEventListener('mouseup', handleMouseUp);
    };
  });

  return (
    <button className={classes.root} type="button" onMouseDown={handleMouseDown}>
      <AccessibilityText>{locale.get('moveHandle')}</AccessibilityText>
    </button>
  );
};

MoveHandle.propTypes = {
  onMove: PropTypes.func,
  setMovedX: PropTypes.func.isRequired,
  setMovedY: PropTypes.func.isRequired,
  /** Explicitly defined X coordinate position. Useful with "movable" property */
  posX: PropTypes.number,
  /** Explicitly defined Y coordinate position. Useful with "movable" property */
  posY: PropTypes.number
};

MoveHandle.defaultProps = {
  onMove: undefined,
  posX: 0,
  posY: 0
};

export default MoveHandle;
